import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../../Baseurl";

const AddSubcategory = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    categoryName: "",
    subCategoryName: "",
    categoryId: "",
  });
  
  const [categories, setCategories] = useState([]); // Categories from API

  // Fetch categories on component mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllCategories`);
        setCategories(response.data.data); // Accessing the 'data' field which contains the category array
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  // Handle Modal Open/Close
  const handleShowModal = () => {
    setModalData({ categoryName: "", subCategoryName: "", categoryId: "" });
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  // Handle Form Submission (Add New Subcategory)
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Log modalData to check its contents
    console.log("Modal Data:", modalData);
  
    // Log the data being sent
    console.log("Submitted data:", { 
      subCategoryName: modalData.subCategoryName,
      categoryId: modalData.categoryId,
    });
  
    try {
      // Add new subcategory
      await axios.post(`${baseurl}addSubcategory`, { 
        subCategoryName: modalData.subCategoryName,
        categoryId: modalData.categoryId,
      });
  
      Swal.fire({
        title: "Success!",
        text: "Subcategory added successfully.",
        icon: "success",
        confirmButtonText: "Ok",
      }).then(() => {
        // Reload the page after closing the success message
        window.location.reload();
      });
  
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        title: "Error!",
        text: "There was an error saving the subcategory.",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };
  
  


  return (
    <>
      <button className="addbtn" onClick={handleShowModal}>
        Add Subcategory
      </button>

      {/* Bootstrap Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Subcategory</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Category Dropdown */}
                  <div className="mb-3 text-start">
                    <label htmlFor="category" className="form-label">
                      Select Category
                    </label>
                    <select
                      className="form-control"
                      id="category"
                      value={modalData.categoryId}
                      onChange={(e) =>
                        setModalData({
                          ...modalData,
                          categoryId: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="">Select a category</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.category_name} {/* Adjust based on the API response */}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Subcategory Name */}
                  <div className="mb-3 text-start">
                    <label htmlFor="subCategory" className="form-label">
                      Sub-Category Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="subCategory"
                      placeholder="Enter Sub-Category Here..."
                      value={modalData.subCategoryName}
                      onChange={(e) =>
                        setModalData({
                          ...modalData,
                          subCategoryName: e.target.value,
                        })
                      }
                      required
                    />
                  </div>

                  <div className="text-end">
                    <button type="submit" className="btn submitbtnn">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddSubcategory;
